const isString = (value) => typeof value === 'string';

export const decodeString = (string) => {
  try {
    if (isString(string)) {
      return decodeURIComponent(string);
    }
  } catch (e) {
    // no-op; if any error threw above, the original assignment shouldn't have been overwritten
  }
  return string;
};

export const generateElementKey = (value, length = 20) => {
  if (isString(value)) {
    return value.replace(/\s+/g, '').substring(0, length);
  }
  return value;
};

export const replaceAmpersands = (value) => {
  if (isString(value)) {
    return value.replace(/&amp;/g, '&');
  }
  return value;
};

export default {
  decodeString,
  generateElementKey,
  replaceAmpersands,
};
